import {Component, Inject} from '@angular/core';
import {Expense, ExpenseDetail} from "../../../models/api.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-expense-details-dialog',
  templateUrl: './expense-details-dialog.component.html',
  styleUrl: './expense-details-dialog.component.scss'
})
export class ExpenseDetailsDialogComponent {
  expense: Expense

  constructor(
    public dialogRef: MatDialogRef<ExpenseDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.expense = data
  }

  onCloseClick(): void {
    this.dialogRef.close()
  }
}
